export default __webpack_public_path__ + "static/media/grablogo.1b02399e.png";